import { render, staticRenderFns } from "./evaStudentWrap.vue?vue&type=template&id=c1aad2d2&scoped=true&"
import script from "./evaStudentWrap.vue?vue&type=script&lang=js&"
export * from "./evaStudentWrap.vue?vue&type=script&lang=js&"
import style0 from "./evaStudentWrap.vue?vue&type=style&index=0&id=c1aad2d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aad2d2",
  null
  
)

export default component.exports